import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@bvhi/ui-base";
import { CancelIcon, UpdateIcon } from "@bvhi/ui-icons";
import { ReactNode, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useKeyboardShortcut } from "../hooks/use-keyboard-shortcuts";

export interface ConfirmDialogConfig {
  title: string;
  additionalContent?: ReactNode;
  confirmButtonLabel?: string;
  confirmButtonColor?: "inherit" | "error" | "primary" | "secondary" | "info" | "success" | "warning";
  confirmButtonIcon?: ReactNode;
  cancelButtonLabel?: string;
  cancelButtonIcon?: ReactNode;
}

interface Props {
  overwrite: ConfirmDialogConfig;
  open: boolean;
  onClose: (conirmed: boolean) => void;
}

export const ConfirmDialog = ({ open, onClose, overwrite }: Props) => {
  const { t } = useTranslation(["dialogs", "validation"]);
  const primaryButtonRef = useRef<HTMLButtonElement>(null);

  useKeyboardShortcut({
    key: "Enter",
    onKeyPressed: () => primaryButtonRef.current?.click(),
  });

  return (
    <Dialog
      disableRestoreFocus
      open={open}
      onClose={() => {
        onClose(false);
      }}
    >
      <DialogTitle>{overwrite.title}</DialogTitle>
      <DialogContent>{overwrite?.additionalContent}</DialogContent>
      <DialogActions>
        <Button
          startIcon={overwrite?.cancelButtonIcon ?? <CancelIcon />}
          variant="text"
          onClick={() => {
            onClose(false);
          }}
        >
          {overwrite?.cancelButtonLabel ?? t("dialogs:dialogs.cancel")}
        </Button>
        <Button
          ref={primaryButtonRef}
          color={overwrite?.confirmButtonColor ?? "primary"}
          startIcon={overwrite?.confirmButtonIcon ?? <UpdateIcon />}
          type="submit"
          variant="contained"
          onClick={() => {
            onClose(true);
          }}
        >
          {overwrite?.confirmButtonLabel ?? t("dialogs:dialogs.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
